import { flagDe, flagEs, flagFr, flagPt, flagUs } from '@ng-icons/flag-icons';

/**
 * Build-time registry of the language-catalog flags.
 *
 * `CoreLang.image` stores a flag country code (`'es'`, `'us'`, …) — see
 * `backend/src/@aurora/modules/lang/core-langs.ts`. ng-icons cannot import
 * icons at runtime (icons are tree-shaken TS constants), so every flag the
 * catalog may reference must be registered here at build time and resolved
 * by name with `langFlagIconName`.
 *
 * Adding a language to the catalog ⇒ add its flag import here, in the same
 * PR that touches `coreLangs` and `environment.lang.langs`.
 */
export const langFlagIcons: Record<string, string> = {
  flagDe,
  flagEs,
  flagFr,
  flagPt,
  flagUs,
};

/**
 * Resolve the ng-icons name (`'flagEs'`) for a catalog flag country code
 * (`'es'`). Returns `undefined` when the code is empty or its flag is not
 * registered in `langFlagIcons`, so callers can render a text fallback.
 */
export function langFlagIconName(image: string | null | undefined): string | undefined {
  if (!image) return undefined;

  const name = `flag${image.charAt(0).toUpperCase()}${image.slice(1)}`;

  return name in langFlagIcons ? name : undefined;
}
